<template>
  <div v-if="src" class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close"><span class="blind">close</span></button>
      <PinchZoom
        :overflow="'visible'">
        <img :src="src" alt="">
      </PinchZoom>
    </div>
  </div>
</template>

<script>
import PinchZoom from 'vue-pinch-zoom'

export default {
  props: [
    'locale',
    'lang',
    'src'
  ],
  components: {
    PinchZoom
  },
  created () {
    window.addEventListener('popstate', this.winPopstate)
    document.body.classList.add('layerOn')
  },
  beforeDestroy () {
    document.body.classList.remove('layerOn')
  },
  data () {
    return {
    }
  },
  methods: {
    winPopstate (e) {
      this.close()
    },
    close () {
      this.$store.commit('setImgSrc', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  padding-left: 0;
  padding-right: 0;
  background-color: rgba(0,0,0,0.9);
  z-index: 999999999;
  .inner {
    display: flex !important;
    align-items: center;
    justify-content: center;
    max-width: none;
    height: 100%;
    padding: 0;
    background: none;
  }
}
</style>
